// extracted by mini-css-extract-plugin
module.exports = {"loadingSection":"SSO_loadingSection__3cJH_","loadingBox":"SSO_loadingBox__349Ye","lottie":"SSO_lottie__IxG9k","lottieContainer":"SSO_lottieContainer__1Sj6e"};